export const importFromCsv = {
  tankTitle: '洗濯機へのCSVタンクインポート',
  importTankSuccessfully: 'タンクを洗濯機に正常にインポートしました！',
  importTankFailed: 'タンクの洗濯機へのインポートに失敗しました！',
  importSuccessfully: '洗濯機のインポートに成功しました！',
  importFailed: '洗濯機のインポートに失敗しました！',
}
